import React from 'react';
import { Neo, Views } from '@singularsystems/neo-react';
import AuthorisableTransactionsVM from './AuthorisableTransactionsVM';
import { observer } from 'mobx-react';
import { TextConstants } from '../../../../Common/TextConstants';
import AuthorisableUpdateRequestsByStatus from '../Components/AuthorisableUpdateRequestsByStatus';


class AuthorisableTransactionsParams {
    public authorisableStatus = {}
}

@observer
export default class AuthorisableTransactionsView extends Views.ViewBase<AuthorisableTransactionsVM, AuthorisableTransactionsParams> {
   public static params = new AuthorisableTransactionsParams();

    constructor(props: unknown) {
        super("Authorisable Transactions", AuthorisableTransactionsVM, props);
    }

    protected initialise(): void | Promise<any> {
        this.viewModel.status = this.viewParams.authorisableStatus.asString();
        this.viewModel.initialise();
    }

    public render() {
        return (
            <>
              <Neo.Card title={TextConstants.Titles.BatchColumnHeadings} className="m-1">
                <Neo.TabContainer variant="flat">                  
                  <Neo.Tab header={TextConstants.GeneralText.Pending}>
                    <AuthorisableUpdateRequestsByStatus viewModel={this.viewModel.pendingStatusVM}/>
                  </Neo.Tab>
                  <Neo.Tab header={TextConstants.GeneralText.Declined}>
                    <AuthorisableUpdateRequestsByStatus viewModel={this.viewModel.declinedStatusVM}/>
                 </Neo.Tab> 
                  <Neo.Tab header={TextConstants.GeneralText.Processed}>
                    <AuthorisableUpdateRequestsByStatus viewModel={this.viewModel.processedStatusVM}/>
                 </Neo.Tab>                 
                </Neo.TabContainer>
              </Neo.Card>
            </>
        );
    }
}